import type { ReactNode } from 'react';

/**
 * Search box plus date range, the filter strip every grid screen has.
 * Mirrors the txtSearch / dtpStart / dtpEnd trio on the desktop forms, which
 * reloaded the grid on every change — same here, via the query key.
 */
export default function FilterBar({
  search,
  onSearchChange,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  searchLabel = 'Kërko',
  searchPlaceholder = 'Shkruani për të filtruar…',
  children,
}: {
  search: string;
  onSearchChange: (value: string) => void;
  startDate: string;
  onStartDateChange: (value: string) => void;
  endDate: string;
  onEndDateChange: (value: string) => void;
  searchLabel?: string;
  searchPlaceholder?: string;
  /** Buttons rendered at the right of the strip. */
  children?: ReactNode;
}) {
  return (
    <div className="rounded-xl bg-white p-4">
      <div className="flex flex-wrap items-end gap-3">
        <div className="min-w-52 flex-1">
          <label className="mb-1 block text-xs font-medium text-muted" htmlFor="filter-search">
            {searchLabel}
          </label>
          <input
            id="filter-search"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder={searchPlaceholder}
            className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100"
          />
        </div>

        <div>
          <label className="mb-1 block text-xs font-medium text-muted" htmlFor="filter-start">
            Prej
          </label>
          <input
            id="filter-start"
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            className="rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-brand-500"
          />
        </div>

        <div>
          <label className="mb-1 block text-xs font-medium text-muted" htmlFor="filter-end">
            Deri
          </label>
          <input
            id="filter-end"
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            className="rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-brand-500"
          />
        </div>

        {children && <div className="ml-auto flex flex-wrap gap-2">{children}</div>}
      </div>
    </div>
  );
}

/** Shared button styles, so every screen's toolbar matches. */
export const btn = {
  primary:
    'rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50',
  secondary:
    'rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50',
};
